import firebaseApp from "../../Firebase/firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function eliminar_almacen_cultivo_en_proceso(infoProducto) {
  let collectionRef = collection(db, "Campo_secciones".replace(/ /g, ""));
  const docuRef = doc(collectionRef, infoProducto.valor);
  const eliminado = await deleteDoc(docuRef);

  return eliminado;
}
